import React from 'react';
import { Button, Form, Row } from 'react-bootstrap';

interface IDiscoverySearchFilterProps {
    handleChanges: (evt: React.ChangeEvent<HTMLInputElement>) => void;
    handleClicks: () => void;
}

export function DiscoverySearchFilter({ handleChanges, handleClicks }: IDiscoverySearchFilterProps) {
    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="User ID"
                        className="autocomplete-input"
                        name="userId"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Campaign ID"
                        className="autocomplete-input"
                        name="campaignId"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="Company ID"
                        className="autocomplete-input"
                        name="companyId"
                        onChange={handleChanges}
                    />
                </div>
            </Row>
            <Button className="mt-4" onClick={() => handleClicks()}>
                Search
            </Button>
        </Form>
    );
}
